import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed, ref } from 'vue'
import RankingChart from '@/views/dashboard/_components/ranking-chart/ranking-chart.vue'
import TimeRangeSelect from '@/views/dashboard/_components/time-range-select/time-range-select.vue'
import { TimeRange } from '@/views/dashboard/_components/time-range-select/time-range.enum'

interface RankingItem {
  name: string
  department: string
  count: number
  device_id?: string
  group_id?: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'login-ranking-chart',
  props: {
    data: { default: () => [
    { name: '小黑', department: '产品部', count: 25 },
    { name: '小黑', department: '产品部', count: 22 },
    { name: '小黑', department: '产品部', count: 20 },
    { name: '小黑', department: '产品部', count: 18 },
    { name: '小黑', department: '产品部', count: 15 }
  ] },
    timeRange: { default: TimeRange.DAYS_30 }
  },
  emits: ["update:timeRange", "view-all", "rowClick"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const props = __props

const emit = __emit

const loading = ref(false)

const timeRange = computed({
  get: () => props.timeRange,
  set: (val) => emit('update:timeRange', val)
})

function handleItemClick(item: RankingItem & { rank?: number }) {
  if (!(item.count > 0)) return
  emit('rowClick', {
    count: item.count,
    chartTimeRange: timeRange.value,
    computerName: item.name,
    groupId: item.group_id,
    deviceId: item.device_id,
  })
}

__expose({
  loading
})

return (_ctx: any,_cache: any) => {
  const _component_el_tag = _resolveComponent("el-tag")!

  return (_openBlock(), _createBlock(RankingChart, {
    title: _ctx.$t('remoteAuth.loginRankTitle'),
    data: _ctx.data,
    "time-range": timeRange.value,
    "onUpdate:timeRange": [
      _cache[1] || (_cache[1] = ($event: any) => ((timeRange).value = $event)),
      _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('update:timeRange', $event)))
    ],
    loading: loading.value,
    "onUpdate:loading": _cache[2] || (_cache[2] = ($event: any) => ((loading).value = $event)),
    "show-time-range": false,
    unit: _ctx.$t('remoteAuth.unitTimes'),
    "name-key": "name",
    "item-key-field": "device_id",
    "row-clickable": "",
    onItemClick: handleItemClick
  }, {
    titleAfter: _withCtx(() => [
      _createVNode(_component_el_tag, {
        size: "small",
        type: "primary"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('common.rankTagTop5')), 1)
        ]),
        _: 1
      })
    ]),
    headerRight: _withCtx(() => [
      _createVNode(TimeRangeSelect, {
        modelValue: timeRange.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((timeRange).value = $event)),
        "show-all": true
      }, null, 8, ["modelValue"])
    ]),
    "item-name": _withCtx(({ item }) => [
      _createTextVNode(_toDisplayString(item.name) + " (" + _toDisplayString(item.department) + ") ", 1)
    ]),
    _: 1
  }, 8, ["title", "data", "time-range", "loading", "unit"]))
}
}

})